export const INITIAL_FORM_MATERIALS = {
  description: '',
  id: '',
  localizations: [],
}
